// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__13nGf","label":"styles_label__29kqS","value":"styles_value__2X0dQ"};